<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t1">The Positions of Love Box Set</span></p>
<p class="p0">By J.M. Snyder</p>
<p class="p3">* * * *</p>
<p class="p0"><span class="t4">Table of Contents:</span></p>
<p class="p2"><a id="a5"></a><a href="#/005#a18">Book 1: The Positions of Love</a></p>
<p class="p2"><span href="#/006#a19" title="Link target outside of Sample">Book 2: Two Pillars Position</span></p>
<p class="p2"><span href="#/007#a20" title="Link target outside of Sample">Book 3: Clasping Position</span></p>
<p class="p2"><span href="#/008#a21" title="Link target outside of Sample">Book 4: Hammock Position</span></p>
<p class="p2"><span href="#/009#a22" title="Link target outside of Sample">Book 5: Two Dogs Position</span></p>
<p class="p2"><span href="#/010#a23" title="Link target outside of Sample">Book 6: Cowboy Position</span></p>
<p class="p2"><span href="#/011#a24" title="Link target outside of Sample">Book 7: Kneeling Butterfly Position</span></p>
<p class="p2"><span href="#/012#a25" title="Link target outside of Sample">Book 8: Pillar and the Ivy Position</span></p>
<p class="p2"><span href="#/013#a26" title="Link target outside of Sample">Book 9: Tripod Position</span></p>
<p class="p2"><span href="#/014#a27" title="Link target outside of Sample">Book 10: Lotus Position</span></p>
<p class="p2"><span href="#/015#a28" title="Link target outside of Sample">Book 11: The Arc Position</span></p>
<p class="p2"><span href="#/016#a29" title="Link target outside of Sample">Book 12: Sideways Position</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?5382fe79